(function(){
  function init(){
    var r=document.getElementById('gw-hero');
    if(!r||r.dataset.init)return; r.dataset.init='1';
    var figs=[].slice.call(r.querySelectorAll('.gw-fig')),
        cps=[].slice.call(r.querySelectorAll('.gw-c')),
        fill=r.querySelector('.gw-fill'),
        cur=r.querySelector('.gw-cur'),
        stage=r.querySelector('.gw-stage'),
        n=figs.length,i=0,el=0,last=0,paused=false,
        DUR=parseInt(r.dataset.dur,10)||6000,
        red=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!n)return;
    function show(k){
      i=(k+n)%n;
      figs.forEach(function(f,j){f.classList.toggle('on',j===i);});
      cps.forEach(function(c,j){c.classList.toggle('on',j===i);});
      if(cur)cur.textContent=('0'+(i+1)).slice(-2);
      el=0; if(fill)fill.style.width='0%';
    }
    var pv=r.querySelector('.gw-prev'),nx=r.querySelector('.gw-next');
    if(pv)pv.addEventListener('click',function(){show(i-1);});
    if(nx)nx.addEventListener('click',function(){show(i+1);});
    r.addEventListener('mouseenter',function(){paused=true;});
    r.addEventListener('mouseleave',function(){paused=false;});
    r.addEventListener('focusin',function(){paused=true;});
    r.addEventListener('focusout',function(){paused=false;});
    r.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'){show(i-1);}
      if(e.key==='ArrowRight'){show(i+1);}
    });
    document.addEventListener('visibilitychange',function(){paused=document.hidden;});
    var x0=null;
    if(stage){
      stage.addEventListener('pointerdown',function(e){
        x0=e.clientX; stage.classList.add('drag');
        try{stage.setPointerCapture(e.pointerId);}catch(err){}
      });
      stage.addEventListener('pointerup',function(e){
        stage.classList.remove('drag');
        if(x0===null)return;
        var dx=e.clientX-x0; x0=null;
        if(Math.abs(dx)>50){show(i+(dx<0?1:-1));}
      });
      stage.addEventListener('pointercancel',function(){x0=null;stage.classList.remove('drag');});
    }
    function tick(ts){
      if(!last)last=ts;
      var dt=ts-last; last=ts;
      if(!paused&&!red&&n>1){
        el+=dt;
        var pr=Math.min(el/DUR,1);
        if(fill)fill.style.width=(pr*100)+'%';
        if(pr>=1){show(i+1);}
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();